// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-profile .content-wrapper {
  padding: 20px 14px 10px;
  border-radius: 12px;
  background-color: white;
  box-shadow: 0 10px 30px 0 var(--light-gray);
}

.page-profile .description-content {
}

.page-profile .description-content .title {
  margin-bottom: 6px;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
}

.page-profile .description-content .description {
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: var(--dark-gray);
}

.page-profile .indicator-container {
  display: flex;
  flex-direction: column;
  position: relative;
}

.page-profile .indicator-container .value {
  position: absolute;
  left: 75px;
  padding: 5px 10px;
  width: max-content;
  border-radius: 6px;

  font-size: 17px;
  font-weight: 700;
  line-height: 22px;
  color: white;
  background-color: var(--dark-gray);
}

.page-profile .indicator-container .value.underweight {
  left: 0;
}

.page-profile .indicator-container .value.overweight {
  left: 150px;
}

.page-profile .indicator-container .value::before {
  content: '';
  position: absolute;
  top: 30px;
  left: 45px;
  border-right: solid 10px transparent;
  border-left: solid 10px transparent;
  border-top: solid 10px var(--dark-gray);
}

.page-profile .indicator-container .line {
  margin-top: 56px;
  height: 8px;
  border-radius: 20px;
  background: var(--gradient);
}

.page-profile .indicator-container .switcher {
  height: 22px;
  width: 22px;
  border-radius: 50%;
  border: 2px solid var(--light-gray);
  background-color: var(--very-light-gray);

  position: absolute;
  top: 50px;
  left: 115px;
}

.page-profile .indicator-container .switcher.underweight {
  left: 44px;
}

.page-profile .indicator-container .switcher.overweight {
  left: 195px;
}

.page-profile .indicator-container .description-container {
  display: flex;
  justify-content: space-around;
  margin: 24px 0 14px;
  text-align: center;
}

.page-profile .indicator-container .description-container .bmi-item-description {
  /*width: 25%;*/
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: var(--dark-gray);
}

.page-profile .indicator-container .description-container .bmi-item-description.active {
  font-weight: 700;
  color: black;
}

.page-profile .bmi-description {
  margin: 10px 0;
  padding: 8px 12px;
  border-radius: 20px;
  background-color: var(--light-gray);
}

.page-profile .bmi-description .item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  line-height: 18px;
}

.page-profile .bmi-description .item img {
  width: 32px;
  height: 32px;
  max-width: unset;
}

.page-profile .bmi-description .item .text {
  font-weight: 700;
}

.page-profile .bmi-description .item .description {
  font-weight: 400;
}

.page-profile .skin {
  text-align: center;
}

.page-profile .skin img {
  display: inline-block;
  height: 152px;
}

.page-profile .personal-information {
  border-top: 1px solid var(--light-gray);
  border-bottom: 1px solid var(--light-gray);
}

.page-profile .personal-information .data-description {
  padding: 20px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 16px;
}

.page-profile .personal-information .data-description .item {
  display: flex;
  gap: 8px;
  min-width: 140px;
  max-width: calc(50% - 8px);
  flex-grow: 2;
}

.page-profile .personal-information .data-description .item img {
  width: 32px;
  height: 32px;
}

.page-profile .personal-information .data-description .item .text {
  margin-bottom: 4px;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
}

.page-profile .personal-information .data-description .item .description {
  max-width: 100px;
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
}

.page-profile .personal-information .data-description .item:first-child .description {
  /* user input should be broken */

  word-break: break-word;
}

.page-profile .description-bmi {
  margin-top: 10px;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}

.page-profile .button-container {
  margin: 40px 0 80px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/profile.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;AACA;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;;EAElB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;;EAExC,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;;EAEhC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".page-profile .content-wrapper {\n  padding: 20px 14px 10px;\n  border-radius: 12px;\n  background-color: white;\n  box-shadow: 0 10px 30px 0 var(--light-gray);\n}\n\n.page-profile .description-content {\n}\n\n.page-profile .description-content .title {\n  margin-bottom: 6px;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 24px;\n}\n\n.page-profile .description-content .description {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 20px;\n  color: var(--dark-gray);\n}\n\n.page-profile .indicator-container {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.page-profile .indicator-container .value {\n  position: absolute;\n  left: 75px;\n  padding: 5px 10px;\n  width: max-content;\n  border-radius: 6px;\n\n  font-size: 17px;\n  font-weight: 700;\n  line-height: 22px;\n  color: white;\n  background-color: var(--dark-gray);\n}\n\n.page-profile .indicator-container .value.underweight {\n  left: 0;\n}\n\n.page-profile .indicator-container .value.overweight {\n  left: 150px;\n}\n\n.page-profile .indicator-container .value::before {\n  content: '';\n  position: absolute;\n  top: 30px;\n  left: 45px;\n  border-right: solid 10px transparent;\n  border-left: solid 10px transparent;\n  border-top: solid 10px var(--dark-gray);\n}\n\n.page-profile .indicator-container .line {\n  margin-top: 56px;\n  height: 8px;\n  border-radius: 20px;\n  background: var(--gradient);\n}\n\n.page-profile .indicator-container .switcher {\n  height: 22px;\n  width: 22px;\n  border-radius: 50%;\n  border: 2px solid var(--light-gray);\n  background-color: var(--very-light-gray);\n\n  position: absolute;\n  top: 50px;\n  left: 115px;\n}\n\n.page-profile .indicator-container .switcher.underweight {\n  left: 44px;\n}\n\n.page-profile .indicator-container .switcher.overweight {\n  left: 195px;\n}\n\n.page-profile .indicator-container .description-container {\n  display: flex;\n  justify-content: space-around;\n  margin: 24px 0 14px;\n  text-align: center;\n}\n\n.page-profile .indicator-container .description-container .bmi-item-description {\n  /*width: 25%;*/\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 14px;\n  color: var(--dark-gray);\n}\n\n.page-profile .indicator-container .description-container .bmi-item-description.active {\n  font-weight: 700;\n  color: black;\n}\n\n.page-profile .bmi-description {\n  margin: 10px 0;\n  padding: 8px 12px;\n  border-radius: 20px;\n  background-color: var(--light-gray);\n}\n\n.page-profile .bmi-description .item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n  line-height: 18px;\n}\n\n.page-profile .bmi-description .item img {\n  width: 32px;\n  height: 32px;\n  max-width: unset;\n}\n\n.page-profile .bmi-description .item .text {\n  font-weight: 700;\n}\n\n.page-profile .bmi-description .item .description {\n  font-weight: 400;\n}\n\n.page-profile .skin {\n  text-align: center;\n}\n\n.page-profile .skin img {\n  display: inline-block;\n  height: 152px;\n}\n\n.page-profile .personal-information {\n  border-top: 1px solid var(--light-gray);\n  border-bottom: 1px solid var(--light-gray);\n}\n\n.page-profile .personal-information .data-description {\n  padding: 20px 0;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.page-profile .personal-information .data-description .item {\n  display: flex;\n  gap: 8px;\n  min-width: 140px;\n  max-width: calc(50% - 8px);\n  flex-grow: 2;\n}\n\n.page-profile .personal-information .data-description .item img {\n  width: 32px;\n  height: 32px;\n}\n\n.page-profile .personal-information .data-description .item .text {\n  margin-bottom: 4px;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.page-profile .personal-information .data-description .item .description {\n  max-width: 100px;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 20px;\n}\n\n.page-profile .personal-information .data-description .item:first-child .description {\n  /* user input should be broken */\n\n  word-break: break-word;\n}\n\n.page-profile .description-bmi {\n  margin-top: 10px;\n  text-align: center;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n}\n\n.page-profile .button-container {\n  margin: 40px 0 80px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
